/* eslint-disable jsx-a11y/anchor-is-valid */
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
//import { Languages } from '../header-menus/Languages'
//import { ThemeModeSwitcher } from '../theme-mode/ThemeModeSwitcher'

const UserMenu = () => {
  const { logout } = useAuth()
  const intl = useIntl()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-3 fs-6 w-200px'
      data-kt-menu='true'
    >

      {/* begin::Menu item */}
      <div className='menu-item px-3'>
        <Link to={'account/overview'} className='menu-link px-3'>
          {intl.formatMessage({ id: 'ACCOUNT.MYACCOUNT' })}
        </Link>
      </div>
      {/* end::Menu item */}

      {/* begin::Menu item */}
      <div className='menu-item px-3'>
        <Link to={'account/settings'} className='menu-link px-3'>
          {intl.formatMessage({ id: 'ACCOUNT.SETTINGS' })}
        </Link>
      </div>
      {/* end::Menu item */}

      {/* begin::Menu item */}
      <div className='menu-item px-3'>
        <Link to={'account/notifications'} className='menu-link px-3'>
          {intl.formatMessage({ id: 'ACCOUNT.NOTIFICATIONS' })}
        </Link>
      </div>
      {/* end::Menu item */}

      {/* begin::Menu separator */}
      <div className='separator my-2'></div>
      {/* end::Menu separator */}

      {/* begin::Menu item */}
      <div className='menu-item px-3'>
        <a href='#' className='menu-link px-3'>
          Hilfe
        </a>
      </div>
      {/* end::Menu item */}

      {/* begin::Menu separator */}
      <div className='separator my-2'> </div>
      {/* end::Menu separator */}

      {/*<Languages languageMenuPlacement='right-end' />

      <ThemeModeSwitcher menuPlacement='right-end' />

      <div className='separator my-2'></div> */}
      {/* end::Menu separator */}

      {/* begin::Menu item */}
      <div className='menu-item px-3'>
        <a onClick={logout} className='menu-link px-3'>
          {intl.formatMessage({ id: 'AUTH.LOGOUT.BUTTON' })}
        </a>
      </div>

      {/* begin::Menu item 
      <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>Unternehmen</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>
      {/* end::Menu item */}

      {/* begin::Menu item *
      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='right-end'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        {/* begin::Menu sub *
        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          {/* begin::Menu item 
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>
          {/* end::Menu item */}

      {/* begin::Menu item 
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>
          {/* end::Menu item */}

      {/* begin::Menu item 
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>
          {/* end::Menu item */}

      {/* begin::Menu item
          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>
          {/* end::Menu item */}

      {/* begin::Menu separator 
      <div className='separator my-2'></div>
      {/* end::Menu separator */}

      {/* begin::Menu item 
      <div className='menu-item px-3'>
        <div className='menu-content px-3'>
          <label className='form-check form-switch form-check-custom form-check-solid'>
            <input
              className='form-check-input w-30px h-20px'
              type='checkbox'
              value='1'
              checked={true}
              name='notifications'
              onChange={() => { }}
            />
            <span className='form-check-label text-muted fs-7'>Notifications</span>
          </label>
        </div>
      </div>
      {/* end::Menu item 
    </div>
        {/* end::Menu sub 
      </div >
  {/* end::Menu item */ }
    </div>
  )
}

export { UserMenu }
